export enum EditableStatus {
	UNMODIFIED = 0,
	INSERTED = 1,
	MODIFIED = 2,
	DELETED = 3,
	APPROVED = 4,
	REJECTED = 5,
}
export enum UserRole {
	MECHANIC = 'M',
	SERVICE_ADVISER = 'N',
	CALL_CENTER = 'C',
	PARTS_MANAGER = 'V',
	ADMIN = 'X',
	CRE = 'H',
}
export enum VehicleBrand {
	SKODA = 'C',
}
export enum ScreenSize {
	TABLET = 768,
	MEDIUM = 992,
	DIALOG_TABLET_WIDTH = '80vw',
	DIALOG_DEFAULT_WIDTH = '50%',
}
export enum HideColumns{
	STAV = 'STAV',
}
export enum CustomerVehicleRefresh {
	CUSTOMER = 1,
	ORDER = 2,
	PLANNEDORDER = 3,
}
export const FILE_TYPE = 'image-document';
export const MAXIMUM_FILE_SIZE = 2000000;
